<!--
入力内容表示コンポーネント
健康状態を変換する
-->
<template>
  <div class="value-font">
    <div v-text="condition" :data-test="dataTest" />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true
    },
    dataTest: String
  },
  computed: {
    condition: function() {
      switch (this.value) {
        case 0:
          return this.$i18n.t("yourPhysicalInformation.healthy");
        case 1:
          return this.$i18n.t("yourPhysicalInformation.physicallyDisabled");
        case 2:
          return this.$i18n.t("yourPhysicalInformation.brainDisabled");
        case 3:
          return this.$i18n.t("yourPhysicalInformation.visuallyImpaired");
        case 4:
          return this.$i18n.t("yourPhysicalInformation.hearingImpaired");
        case 5:
          return this.$i18n.t("yourPhysicalInformation.laguageDisabled");
        case 6:
          return this.$i18n.t("yourPhysicalInformation.intellectuallyDisabled");
        case 7:
          return this.$i18n.t("yourPhysicalInformation.mentalyDisabled");
        case 9:
          return this.$i18n.t("yourPhysicalInformation.otherDisabilities");
      }
    }
  }
};
</script>

<style scoped>
.value-font {
  font-weight: bold;
}
</style>
